import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Menu,
  X,
  Search,
  User,
  ShoppingCart,
  ChevronDown,
  Home,
  PhoneCall,
} from "lucide-react";

import { useDispatch, useSelector } from "react-redux";

import { Facebook, Instagram, Twitter } from "lucide-react";
import { FaTiktok } from "react-icons/fa";
import { facebooklink, instagramlink } from "./SocialMediaLink";
import { setAuthModalOpen } from "store/features/authModalSlice";
import { motion, AnimatePresence } from "framer-motion";
import { mobileMenuVariants } from "animations/variants";
import { menu } from "data/data";
import LanguageToggle from "./LanguageToggle";
import LanguageToggleMobile from "./LanguageToggleMobile";

const Navbar = () => {
  const [open, setOpen] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const lang = useSelector((state) => state.language.lang);

  const { user } = useSelector((state) => state.user || {});

  const isOpen = useSelector((state) => state.authModal.authModalOpen);
  const [activeMobileMenu, setActiveMobileMenu] = useState(null);
  const scrollToSection = (id) => {
    setOpen(false);

    navigate({
      pathname: "/",
      hash: id,
    });
  };

  const visibleMenu = menu.filter((item) => item.showHeader !== false);

  const goToIndustry = () => {
    setOpen(false);

    if (location.pathname !== "/") {
      navigate("/#latestworkshop");
      return;
    }

    const el = document.querySelector("#latestworkshop");
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const goHome = () => {
    setOpen(false);

    if (location.pathname !== "/") {
      navigate("/#hero"); // 👈 go to homepage
      return;
    }

    // If already on homepage → scroll to top
    const el = document.querySelector("#hero");
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  const MobileMenuDivider = () => (
    <div className="relative my-3 flex items-center justify-center">
      {/* left dotted line */}
      <div className="flex-1 border-t border-dashed border-neonYellow/50"></div>

      {/* center dots */}
      <div className="mx-4 flex items-center gap-1">
        <span className="w-1 h-1 bg-neonYellow rounded-full"></span>
        <span className="w-1 h-1 bg-neonYellow rounded-full"></span>
        <span className="w-1 h-1 bg-neonYellow rounded-full"></span>
        <span className="w-1 h-1 bg-neonYellow rounded-full"></span>
        <span className="w-1 h-1 bg-neonYellow rounded-full"></span>
      </div>

      {/* right dotted line */}
      <div className="flex-1 border-t border-dashed border-gray-600/50"></div>
    </div>
  );

  const goTo = (path) => {
    setOpen(false);
    navigate(path);
  };

  const getLabel = (label) => {
    if (!label) return "";

    let text = "";

    if (typeof label === "string") {
      text = label;
    } else if (typeof label === "object") {
      text = label?.[lang] || label?.en || "";
    }

    return text.toUpperCase();
  };

  return (
    <nav className="fixed top-0 left-0 w-full h-[80px] bg-darkbg z-50">
      <div className="max-w-6xl mx-auto flex items-center justify-between p-4">
        <img
          src="/maria/logongang.png"
          width={150}
          className="cursor-pointer"
          onClick={goHome}
        />

        {/* DESKTOP MENU */}
        <div className="hidden md:flex space-x-8 text-sm font-medium text-text">
          <button
            onClick={goHome}
            className="group flex items-center justify-center"
          >
            <Home
              size={20}
              className="text-reddark hover:text-darkbg hover:scale-110 transition-all duration-300"
            />
          </button>
          {visibleMenu?.map((item, index) => {
            if (item.type === "dropdown") {
              console.log("LABEL:", item.label, typeof item.label);
              console.log(JSON.stringify(item.label));

              return (
                <div key={index} className="relative group flex items-center">
                  <button
                    className="hover:text-darkbg hover:animate-neonFlicker transition"
                    onClick={() => item.path && navigate(item.path)}
                  >
                    {getLabel(item.label)}
                  </button>

                  <div
                    className="
              absolute left-0 top-full mt-4
              w-64
              bg-white text-black
              border border-black
              opacity-0 invisible
              group-hover:opacity-100 group-hover:visible
              transition-all duration-300
              shadow-lg
              z-50
            "
                  >
                    <ul className="py-3">
                      {item?.children?.map((sub, subIndex) => (
                        <li key={subIndex}>
                          <button
                            onClick={() => navigate(sub.path)}
                            className="relative w-full text-left px-6 py-3 uppercase tracking-wide group/item"
                          >
                            {getLabel(sub.label)}{" "}
                            <span
                              className="
                        absolute left-6 bottom-2
                        h-[2px] w-0
border-b border-dotted border-reddark                        transition-all duration-300
                        group-hover/item:w-[calc(100%-3rem)]
                      "
                            />
                          </button>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              );
            }

            if (item.type === "scroll") {
              return (
                <button
                  key={index}
                  className="relative group"
                  onClick={() => {
                    if (item.key === "insights") {
                      goToIndustry();
                    } else {
                      navigate(item.path);
                    }
                  }}
                >
                  <span className="hover:text-darkbg hover:animate-neonFlicker transition">
                    {getLabel(item.label)}
                  </span>

                  <span
                    className="
        absolute left-0 -bottom-1
        h-[2px] w-full
        border-b border-dotted border-reddark
        scale-x-0 origin-left
        transition-transform duration-300
        group-hover:scale-x-100
      "
                  />
                </button>
              );
            }

            return null;
          })}
        </div>
        <div className="hidden md:flex space-x-4 text-sm font-medium text-text">
          <button
            onClick={() => navigate("/contact")}
            className="
    group
    shrink-0
    inline-flex items-center gap-2
    rounded-full
    bg-gradient-to-r from-reddark to-redlight
    px-6 py-3
    text-white
    font-semibold
    tracking-wide
    shadow-[0_8px_25px_rgba(139,0,0,0.25)]
    hover:shadow-[0_12px_35px_rgba(139,0,0,0.35)]
    hover:-translate-y-0.5
    transition-all duration-300 uppercase
  "
          >
            <PhoneCall
              size={16}
              className="transition-transform duration-300 group-hover:rotate-12"
            />

            <span className="">
              {lang === "vi" ? "Đặt Lịch" : "Book a Call"}
            </span>
          </button>
          <LanguageToggle />{" "}
        </div>

        {/* MOBILE BURGER ICON */}
        <div className="flex space-x-2 md:hidden">
          <LanguageToggleMobile />

          <button className=" text-reddark" onClick={() => setOpen(!open)}>
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </div>

      {/* MOBILE DROPDOWN MENU */}
      <AnimatePresence>
        {open && (
          <motion.div
            variants={mobileMenuVariants}
            initial="hidden"
            animate="show"
            exit="exit"
            className="
        md:hidden
        fixed top-[80px] left-0 w-full
        bg-darkbg
        overflow-hidden
        z-40
      "
          >
            {" "}
            <div className="h-[90vh] overflow-y-auto scrollbar-thin">
              <div className="flex flex-col text-sm tracking-widest divide-y divide-gray-300 mt-4">
                <button
                  onClick={() => {
                    goHome();
                    setOpen(false);
                  }}
                  className="
      px-6 py-5
      text-left
      text-reddark
      uppercase
      text-md
      relative
      group
      flex items-center gap-3
    "
                >
                  <span>{lang === "vi" ? "Trang Chủ" : "Home"}</span>

                  <span
                    className="
        absolute left-6 -bottom-1
        h-[2px] w-[calc(100%-3rem)]
        border-b border-dotted border-reddark
        scale-x-0 origin-left
        transition-transform duration-300
        group-hover:scale-x-100
      "
                  />
                </button>
                {menu?.map((item, index) => {
                  const isDropdown = item.type === "dropdown";
                  const isActive = activeMobileMenu === index;

                  if (isDropdown) {
                    return (
                      <div key={index} className="px-6 py-5">
                        <button
                          onClick={() =>
                            setActiveMobileMenu(isActive ? null : index)
                          }
                          className="w-full flex justify-between items-center text-left text-reddark uppercase text-md relative group"
                        >
                          <span>{getLabel(item.label)}</span>
                          <ChevronDown
                            size={18}
                            className={`transition-transform duration-300 ${
                              isActive ? "" : "-rotate-90"
                            }`}
                          />
                          <span className="absolute left-0 -bottom-1 w-full border-b border-dotted border-reddark scale-x-0 origin-left transition-transform duration-300 group-hover:scale-x-100" />{" "}
                        </button>

                        <div
                          className={`overflow-hidden transition-all duration-300 ${
                            isActive ? "max-h-96 mt-4" : "max-h-0"
                          }`}
                        >
                          <div className="flex flex-col space-y-4 pl-4 pt-4">
                            {item?.children?.map((sub, subIndex) => (
                              <button
                                key={subIndex}
                                onClick={() => {
                                  navigate(sub.path);
                                  setOpen(false);
                                  setActiveMobileMenu(null);
                                }}
                                className="text-left text-reddark font-light uppercase text-sm relative group"
                              >
                                {getLabel(sub.label)}{" "}
                                <span className="absolute left-0 -bottom-1 w-full border-b border-dotted border-reddark scale-x-0 origin-left transition-transform duration-300 group-hover:scale-x-100" />{" "}
                              </button>
                            ))}
                          </div>
                        </div>
                      </div>
                    );
                  }

                  return (
                    <button
                      key={index}
                      onClick={() => {
                        if (item.type === "scroll") {
                          if (item.key === "insights") {
                            goToIndustry();
                          } else {
                            navigate(item.path);
                          }
                        }
                        setOpen(false);
                      }}
                      className="px-6 py-5 text-left text-reddark uppercase text-md relative group"
                    >
                      {getLabel(item.label)}

                      <span className="absolute left-6 -bottom-1 h-[2px] w-[calc(100%-3rem)] bg-neonYellow scale-x-0 origin-left transition-transform duration-300 group-hover:scale-x-100" />
                    </button>
                  );
                })}
                <button
                  onClick={() => navigate("/contact")}
                  className="
    group
    shrink-0
    inline-flex items-center gap-2
    rounded-full
    bg-gradient-to-r from-reddark to-redlight
    px-6 py-3
    text-white
    font-semibold
    tracking-wide
    shadow-[0_8px_25px_rgba(139,0,0,0.25)]
    hover:shadow-[0_12px_35px_rgba(139,0,0,0.35)]
    hover:-translate-y-0.5
    transition-all duration-300 uppercase mx-6 my-4
  "
                >
                  <PhoneCall
                    size={16}
                    className="transition-transform duration-300 group-hover:rotate-12"
                  />

                  <span className="">
                    {lang === "vi" ? "Đặt Lịch" : "Book a Call"}
                  </span>
                </button>
              </div>

              <div className="px-6 py-10 text-center space-y-6">
                <div className="space-y-1">
                  <p className="text-xs tracking-widest text-gray-400 uppercase">
                    Write
                  </p>
                  <p className="text-sm text-reddark">
                    maria@mariaadvisory.com
                  </p>
                </div>

                <div className="space-y-1">
                  <p className="text-xs tracking-widest text-gray-400 uppercase">
                    Call
                  </p>
                  <p className="text-sm text-reddark">(+64) 3 345 6789</p>
                </div>

                <MobileMenuDivider />

                <div className="flex justify-center gap-6 text-gray-400">
                  <a
                    href={facebooklink}
                    className="hover:text-reddark transition"
                  >
                    <Facebook size={18} />
                  </a>
                  <a
                    href={instagramlink}
                    className="hover:text-reddark transition"
                  >
                    <Instagram size={18} />
                  </a>
                </div>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};

export default Navbar;
